import {WithIdSchema} from './api/definitions';
import {ObjectIdSchema} from './zod';
import {z} from 'zod';
import {AccountWithLogoSchema} from './scoredAccounts';

export const MaxTagsLimit = 100;

export const TagSchema = z.object({
  customerId: ObjectIdSchema,
  timestamp: z.date(),
  name: z.string(),
  deleted: z.boolean().optional(),
});
export type Tag = z.infer<typeof TagSchema>;

export const TagResponseSchema = TagSchema.extend(WithIdSchema).omit({
  customerId: true,
});
export type TagResponse = z.infer<typeof TagResponseSchema>;

export const TagDetailsResponseSchema = TagResponseSchema.extend({
  numAccounts: z.number(),
  previewAccounts: z.array(AccountWithLogoSchema),
});
export type TagDetailsResponse = z.infer<typeof TagDetailsResponseSchema>;
